import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { HotelTravelPolicyModel } from '@src/shared/src/models';

type Props = {
  policy: HotelTravelPolicyModel;
};

const HotelPolicyRegionTitle: React.FC<Props> = ({ policy }) => {
  const { t } = useTranslation();

  const regionTitle = () => {
    switch (policy.regionType) {
      case 'anywhere':
        return t('SearchSideBarTravelPolicies.hotel.region.anywhere');
      case 'city_area':
        if (policy.regionName && policy.radius) {
          return t('SearchSideBarTravelPolicies.hotel.region.cityArea', {
            regionName: policy.regionName,
            radius: policy.radius / 1000,
          });
        }
        return policy.regionName;
      default:
        return policy.regionName;
    }
  };

  const title = regionTitle();

  if (!title) return null;

  return (
    <div className="sidebar-travel-policies-haul-title">
      <span>{title}</span>
    </div>
  );
};

export default HotelPolicyRegionTitle;
